import { OptionsType } from '@openx/types/options.ts';
import { useOptionsFetch } from '@openx/utils/apiHooks/generics/useOptionsFetch.tsx';
import { produceSortedOptionsKeys } from '@openx/utils/lib/sortedOptions.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useSelectRateOptionsFetch(
  optionType: typeof OptionsType.VIEWABILITY | typeof OptionsType.VIEW_THROUGH_RATE
) {
  const { t } = useTranslation();
  const optionTypeText = optionType === OptionsType.VIEWABILITY ? 'viewability' : 'view through rate';
  const { isLoading: isSelectRateLoading, data: selectRate } = useOptionsFetch({
    errorMessage: t('Failed to fetch {optionType} options', { optionType: optionTypeText }),
    optionType,
  });

  const optionsList = useMemo(() => produceSortedOptionsKeys(selectRate), [selectRate]);

  return {
    isSelectRateLoading,
    optionsList,
    selectRate,
  };
}
